import { STATUS, TournamentEvent } from "../types/types";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import { useAppSelector } from "../hooks";
import DoneIcon from '@mui/icons-material/Done';
import RestartAltIcon from "@mui/icons-material/RestartAlt";
import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import { useState } from "react";
import AlertDialog from "./alert";
import {
    buttonStyles,
    dialogActionsStyles,
    dialogContentStyles,
    dialogStyles,
} from "../styles/theme";
import { supabase } from "../supabase";

interface Props {
    open: boolean;
    handleClose: () => void;
    event?: TournamentEvent;
}

function TournamentEventUpdateDialog(props: Props) {
    const { open, handleClose, event } = props;
    const [openAlertDialog, setOpenAlertDialog] = useState(false);
    const isAdmin = useAppSelector((state) => state.app.admin);

    const updateEventStatus = async (newStatus: STATUS) => {
        if (!event?.id) return;

        const { error } = await supabase
            .from("tournament_events")
            .update({ status: newStatus })
            .eq("id", event.id);

        if (error) {
            console.error("Error updating tournament event:", error.message);
        } else {
            if (newStatus === STATUS.FINISHED) handleClose();
        }
    };

    const resetEvent = () => {
        if (!event?.id) return;

        updateEventStatus(STATUS.PENDING);
        setOpenAlertDialog(false);
    };

    return (
        <div>
            <AlertDialog
                header="Er du sikker?"
                body="Er du sikker på at du vil nulstille denne begivenhed?"
                open={openAlertDialog}
                yesButtonText="Bekræft"
                yesCallback={resetEvent}
                noButtonText="Annuller"
                noCallback={() => setOpenAlertDialog(false)}
            />
            <Dialog
                sx={dialogStyles}
                open={open}
                onClose={handleClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogContent sx={dialogContentStyles}>
                    <div style={{ padding: "20px", textAlign: "center", color: "white" }}>
                        <h2 style={{ color: "white", marginBottom: "10px" }}>{event?.title}</h2>
                    </div>
                </DialogContent>
                <DialogActions sx={dialogActionsStyles}>
                    {event?.status !== STATUS.FINISHED && (
                        <>
                            <Button
                                sx={buttonStyles}
                                onClick={() => updateEventStatus(STATUS.PLAYING)}
                                disabled={event?.status === STATUS.PLAYING}
                            >
                                Start begivenhed
                            </Button>
                            <Button
                                sx={buttonStyles}
                                onClick={() => updateEventStatus(STATUS.FINISHED)}
                                disabled={event?.status !== STATUS.PLAYING}
                            >
                                Afslut begivenhed
                            </Button>
                        </>
                    )}
                    {event?.status === STATUS.FINISHED && (
                        <Button sx={buttonStyles} onClick={() => setOpenAlertDialog(true)}>
                            <RestartAltIcon />
                        </Button>
                    )}
                </DialogActions>
            </Dialog>
        </div>
    );
}

export default TournamentEventUpdateDialog;
